var React = require('react');

function StrikeThroughInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.181 2.39c3.9-.3 7.8-.604 11.7-.906l.06-.1c-2.382.436-4.76.879-7.142 1.305-2.41.43-4.862.782-7.309.463-.037.035-.07.069-.108.103l16.326-1.378 4.643-.393c.066-.005.22-.113.086-.102L6.11 2.76l-4.644.392c-.037.003-.221.086-.108.103 2.385.312 4.78-.003 7.13-.418 2.476-.435 4.945-.9 7.414-1.353.057-.011.19-.11.06-.1-3.899.302-7.8.606-11.7.907-.065.003-.218.111-.082.1z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":".265"}));
}

StrikeThroughInline.defaultProps = {"width":"90","height":"18","viewBox":"0 0 23.812 4.763"};

module.exports = StrikeThroughInline;

StrikeThroughInline.default = StrikeThroughInline;
